import { DEVICE_PATH } from '@constants/routes';
import { useAppSelector } from '@store/hooks';
import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { useTranslation } from 'react-i18next';
import Table from 'react-bootstrap/Table';
import CloseIcon from '@components/SvgComponents/CloseIcon';
import { FaRegTrashCan } from 'react-icons/fa6';
import { TbDeviceIpadX } from 'react-icons/tb';
import { useNavigate } from 'react-router-dom';
import { getUserName } from '@utils/utils';
import ModalPopUp from '@components/ModalPopUpComponent';
import TextAreaPopUp from '@components/TextAreaPopUpComponent';
import {
    formatDateDMY,
    getDataUsingDeviceId,
    getDataUsingUserId,
} from '@utils/sharedUtils';
import DeviceNurseList from './DeviceNurseList';
import { HOSPITAL } from '@constants/constants';

interface DeviceManagementDetail {
    id: number;
    name: string;
    email: string;
    // Add any other user fields you need
}

type NurseDetails = {
    name: string;
    nurse_id: string;
    date: string;
    id: string;
};

const DeviceManagementDetailPage = () => {
    const deviceDetails = useAppSelector((state) => state.user.deviceDetails);
    const { t } = useTranslation();
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showTextModal, setShowTextModal] = useState(false);
    const [nurseDetails, setNurseDetails] = useState<NurseDetails[]>([]);
    const handleDeleteClick = () => {
        setShowDeleteModal(true);
    };
    const navigate = useNavigate();
    const loggedInUserRole = useAppSelector(
        (state) => state.login.loggedInUserRole
    );

    useEffect(() => {
        if (!deviceDetails) {
            navigate(DEVICE_PATH);
        }
        // console.log('deviceDetails', deviceDetails);
        if (loggedInUserRole.toLowerCase() == HOSPITAL.toLowerCase()) {
            fetchNurseDetails();
        }
    }, [deviceDetails, navigate]);

    const fetchNurseDetails = async () => {
        try {
            if (deviceDetails) {
                const details = await getDataUsingDeviceId(
                    'nurse_device',
                    deviceDetails?.device_uuid
                );
                let assigned = [];
                if (details && details.Items && details.Items.length > 0) {
                    for (const detail of details.Items) {
                        const nurse = await getDataUsingUserId(
                            'user_info',
                            detail?.user_id?.S ? detail?.user_id?.S : ''
                        );
                        if (nurse && nurse.Items && nurse.Items.length > 0) {
                            const nurseData = nurse.Items[0];
                            const data = {
                                name: nurseData?.name?.S
                                    ? nurseData?.name?.S
                                    : '',
                                nurse_id: nurseData?.nurse_id?.S
                                    ? nurseData?.nurse_id?.S
                                    : '',
                                date: detail?.created_at?.S
                                    ? formatDateDMY(detail?.created_at?.S)
                                    : '',
                                id: detail?.id?.S ? detail?.id?.S : '',
                            };
                            assigned.push(data);
                        }
                    }
                    setNurseDetails(assigned);
                }
            }
        } catch (error: any) {
            // setError(error.message);
            console.log('error:', error.message);
        }
        //  finally {
        //     setLoading(false);
        // }
    };

    const handleDelete = () => {
        // Add your logic to handle delete with reason here
        setShowDeleteModal(false);
        setShowTextModal(false);
    };

    const getStatusClass = (status: string) => {
        if (!status) {
            return ''; // Return an empty string if status is undefined or null
        }
        // console.log('Status:', status);
        switch (status.toLowerCase().trim()) {
            case 'approved':
                return 'text-white !text-sm bg-success inline-block rounded-2xl px-3 py-1';
            case 'pending':
                return 'text-white !text-sm bg-warning inline-block rounded-2xl px-3 py-1';
            case 'blocked':
                return 'text-white !text-sm bg-secondary inline-block rounded-2xl px-3 py-1';
            case 'non functional':
                return 'text-white !text-sm bg-danger inline-block rounded-2xl px-3 py-1';
            default:
                return '';
        }
    };

    return (
        <div className="mt-5">
            <div className="flex justify-content-between align-items-center">
                <div className="flex font-bold text-black test-base">
                    <Link to={DEVICE_PATH}>
                        <div className="flex items-center cursor-pointer">
                            <FaArrowLeftLong className="cursor-pointer" />{' '}
                            <div className="font-semibold ml-2">
                                {t('device_details.title')}
                            </div>
                        </div>
                    </Link>
                </div>
                {/* <div className="py-1 px-3 cursor-pointer items-center 2xl:w-56">
                    <button
                        className="text-danger px-3 py-1 rounded-2xl  flex items-center ml-8"
                        onClick={handleDeleteClick}
                    >
                        <span className="text-red mr-2">
                            <FaRegTrashCan className="text-red" />
                        </span>
                        {t('device_details.delete')}
                    </button>
                </div> */}
                <ModalPopUp
                    show={showDeleteModal}
                    message={t('pop_up.device_delete_msg')}
                    onConfirm={() => {
                        setShowTextModal(true);
                        setShowDeleteModal(false);
                    }}
                    onCancel={() => setShowDeleteModal(false)}
                />
                <TextAreaPopUp
                    show={showTextModal}
                    message={t('pop_up.delete_reason_msg')}
                    onConfirm={handleDelete}
                    onCancel={() => {
                        setShowTextModal(false);
                        setShowDeleteModal(false);
                    }}
                />
            </div>
            <div className="cart rounded-2xl bg-white flex flex-col mt-5 2xl:px-5 lg:px-3 lx:px-3 lg:py-3 lx:py-3 2xl:py-4 2xl:w-11/12 ml-5">
                <div className="mb-4">
                    <div className="row">
                        <div className="col">
                            <div className="row">
                                <span className="py-3">
                                    <label className="font-bold text-black">
                                        {t('device_details.device_id')}:
                                    </label>
                                    <span className="ml-3">
                                        {deviceDetails?.device_id
                                            ? deviceDetails?.device_id
                                            : '--'}
                                    </span>
                                </span>
                                <span>
                                    <label className="font-bold text-black">
                                        {t('device_details.added_date')}:
                                    </label>
                                    <span className="ml-3">
                                        {deviceDetails?.created_at
                                            ? deviceDetails?.created_at
                                            : '--'}
                                    </span>
                                </span>
                            </div>
                        </div>
                        <div className="col">
                            <div className="row">
                                <span className="py-3">
                                    <label className="font-bold text-black">
                                        {t('device_details.device_status')}:
                                    </label>
                                    <span className="ml-3">
                                        {deviceDetails?.device_status
                                            ? deviceDetails?.device_status
                                            : '--'}
                                    </span>
                                </span>
                                <span>
                                    <label className="font-bold text-black">
                                        {t('device_details.added_by')}:
                                    </label>
                                    <span className="ml-3">
                                        {deviceDetails?.created_by
                                            ? deviceDetails?.created_by
                                            : '--'}
                                    </span>
                                </span>
                            </div>
                        </div>
                        <div className="col">
                            <div className="row">
                                <span className="py-3">
                                    <label className="font-bold text-black">
                                        {t('device_details.status')}:
                                    </label>
                                    <span
                                        className={`ml-3 text-base font-normal text-table_header
                                ${getStatusClass(deviceDetails?.status ? deviceDetails?.status : '')}`}
                                    >
                                        {deviceDetails?.status}
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                    {/* <div
                        className={` 2xl:mr-11 text-base font-normal text-table_header
                        ${getStatusClass(deviceDetails?.status ? deviceDetails?.status : '')}`}
                    >
                        
                    </div> */}
                </div>
            </div>
            {loggedInUserRole.toLowerCase() == HOSPITAL.toLowerCase() && (
                <>
                    <div className="mt-5">
                        <div className="font-bold text-primary">
                            <div className="flex items-center">
                                <div className="ml-2">
                                    {' '}
                                    {t('device_details.nurse_usage')}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className=" cart bg-white flex flex-col rounded-2xl w-[25rem] h-[29rem] mt-4 ml-4 relative">
                        <DeviceNurseList deviceList={nurseDetails} />
                    </div>
                </>
            )}
        </div>
    );
};

export default DeviceManagementDetailPage;
